import React from 'react';
import VimeoPlayer from '../elements/VimeoPlayer';
import getUrlVars from '../../helpers/getUrlVars';
import tabInfo from '../../helpers/tabInfo';
import apiCall from "../apiCall";

class Vimeo extends React.Component {
  static defaultProps = {
    desktop: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      vimeoId: null,
    }
  }

  componentWillMount() {
    const getParams = getUrlVars();

    if (getParams.publicMaterialId && getParams.publicMaterialId !== 'null') {
      apiCall(`/file/generalMaterial/${getParams.publicMaterialId}`, null, 'GET')
        .then((material) => {
          this.setState({ vimeoId: material.vimeoId || material.alternateId });
        });
    } else {
      apiCall('/user/me')
        .then(() => {
          this.setState({ vimeoId: this.props.match.params.vimeoId });
        });
    }

    if (getParams.windowTitle && getParams.windowTitle !== 'null') {
      tabInfo.setWindowTitle(decodeURIComponent(getParams.windowTitle));
    }
    if (getParams.faviconUrl && getParams.faviconUrl !== 'null') {
      tabInfo.setFavicon(decodeURIComponent(getParams.faviconUrl));
    }
    if (getParams.backgroundUrl && getParams.backgroundUrl !== 'null') {
      this.backgroundUrl = decodeURIComponent(getParams.backgroundUrl);
    }
  }

  render() {
    const { desktop } = this.props;
    return (
      <div style={this.backgroundUrl ? { backgroundImage: `url(${this.backgroundUrl})`, backgroundSize: 'cover', backgroundPosition: 'center' } : {}} className={desktop ? `portal-vimeo portal-home darkBckg${this.backgroundUrl ? ' custom-background' : ''}` : `portal-vimeo portal-home darkBckg${this.backgroundUrl ? ' custom-background' : ''}`}>
        <div className={'container'}>
          <VimeoPlayer vimeoId={this.state.vimeoId} />
        </div>
      </div>
    );
  }
}

export default Vimeo;



// WEBPACK FOOTER //
// ./src/components/routes/Vimeo.js